import { create } from 'zustand';

import type { SpeedOption } from '@/app/(main)/jogo/piao-da-sorte/[id]/_hooks/useSpinningTopSettings';

type SpinningTopSettingsState = {
  autoSpin: boolean;
  speed: SpeedOption;
  isMuted: boolean;
  setAutoSpin: (autoSpin: boolean) => void;
  setSpeed: (speed: SpeedOption) => void;
  setMuted: (isMuted: boolean) => void;
};

export const useSpinningTopSettingsStore = create<SpinningTopSettingsState>((set) => ({
  autoSpin: false,
  speed: 'normal',
  isMuted: false,
  setAutoSpin: (autoSpin: boolean) => set({ autoSpin }),
  setSpeed: (speed: SpeedOption) => set({ speed }),
  setMuted: (isMuted: boolean) => set({ isMuted }),
}));
